import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_EncounterEvent, } from '@app/ehr-emulator-shared';
export const dispatch_onEncounterEventChanged = new ThunderDispatcherV3('__onEncounterEventUpdated');
export class ModuleFE_EncounterEvent_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EncounterEvent, dispatch_onEncounterEventChanged);
        this._v1 = {};
    }
}
export const ModuleFE_EncounterEvent = new ModuleFE_EncounterEvent_Class();
//# sourceMappingURL=ModuleFE_EncounterEvent.js.map